import { BusinessByBadge, ServiceCardData, ServiceDiscount } from '../types';

/**
 * Builds a location string from city and postal code
 */
export const buildLocationString = (
  city?: string | null, 
  postalCode?: string | null,
  fallback: string = 'Location not specified'
): string => {
  const parts = [city, postalCode].filter(Boolean);
  return parts.length > 0 ? parts.join(', ') : fallback;
};

/**
 * Builds a discount object from business data
 */
export const buildDiscountObject = (business: BusinessByBadge): ServiceDiscount | null => {
  if (!business.has_discount) return null;
  
  return {
    id: business.discount_id || '',
    amount: business.discount_percentage || business.discount_amount || 0,
    isPercentage: !!business.discount_percentage,
    appliesToAll: business.discount_applies_to === 'all',
    type: (business.discount_type as 'Paid' | 'Free') || 'Paid',
    description: business.discount_description
  };
};

/**
 * Transforms business data to service card format
 */
export const prepareServiceForCard = (
  service: BusinessByBadge,
  defaultBannerUrl: string = '',
  translations: {
    unknownLocation?: string;
    unnamed?: string;
    uncategorized?: string;
  } = {}
): ServiceCardData => {
  const discount = buildDiscountObject(service);
  
  const location = buildLocationString(
    service.city, 
    service.postal_code,
    translations.unknownLocation || 'Location not specified'
  );

  return {
    id: service.id,
    slug: service.slug,
    name: service.name || translations.unnamed || 'Unnamed Service',
    category: service.category_name || translations.uncategorized || 'Uncategorized',
    imageUrl: service.company_banner_url || service.company_logo || defaultBannerUrl,
    rating: service.avg_rating || 0,
    reviewCount: service.review_count || 0,
    location: location,
    featured: false, // Badge sections don't need featured flag
    discount: discount,
    opening_hours: service.opening_hours || null,
    is_active: service.is_active
  };
};